import { render, staticRenderFns } from "./ruleList.vue?vue&type=template&id=3b1ca66f&scoped=true&"
import script from "./ruleList.vue?vue&type=script&lang=js&"
export * from "./ruleList.vue?vue&type=script&lang=js&"
import style0 from "./ruleList.vue?vue&type=style&index=0&id=3b1ca66f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ca66f",
  null
  
)

export default component.exports